import React from 'react';
import styled from 'styled-components';

// This package
import DoctorImage, { sizeStyles } from './DoctorImage';
import MaybeLazyLoad from './MaybeLazyLoad';
import MaybeOverrideTheme from './MaybeOverrideTheme';
import MaybeCircleMask from './MaybeCircleMask';

export default function DoctorPhoto({
    provider,
    children,
    size,
    useNativeLazyLoad = true,
}) {
    const {
        frontEndCirclePictureUrl,
        frontEndSquarePictureUrl,
        showPhotoWithCircleCss,
    } = provider;

    const url = frontEndCirclePictureUrl || frontEndSquarePictureUrl;

    const needsMask =
        showPhotoWithCircleCss ||
        !frontEndCirclePictureUrl ||
        frontEndSquarePictureUrl === frontEndCirclePictureUrl;

    return (
        <div>
            <MaybeOverrideTheme
                data-test="doctor-photo-theme-provider"
                size={size}
            >
                <MaybeLazyLoad
                    data-test="doctor-photo-lazy-load"
                    useNativeLazyLoad={useNativeLazyLoad}
                >
                    <MaybeCircleMask
                        data-test="doctor-photo-circle-mask"
                        needsMask={needsMask}
                    >
                        <StyledPicture data-test="doctor-card-photo-picture">
                            <DoctorImage
                                altText={provider.nameInSentence}
                                data-test="doctor-card-photo-image"
                                imageSource={url}
                                lazy={useNativeLazyLoad}
                            />
                        </StyledPicture>
                    </MaybeCircleMask>
                </MaybeLazyLoad>
            </MaybeOverrideTheme>

            {children}
        </div>
    );
}

export const StyledPicture = styled.picture`
    ${sizeStyles};
    display: inline-block;

    overflow: hidden;
    border-radius: 50%;
`;
